import { render } from "./tests-desc-skeleton.vue?vue&type=template&id=d8bf13cc&scoped=true"
import script from "./tests-desc-skeleton.vue?vue&type=script&lang=js"
export * from "./tests-desc-skeleton.vue?vue&type=script&lang=js"

import "./tests-desc-skeleton.vue?vue&type=style&index=0&id=d8bf13cc&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8bf13cc"]])

export default __exports__